var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns is-multiline"},_vm._l((_vm.tags),function(tag){return _c('div',{key:tag,staticClass:"column is-one-quarter"},[_c('router-link',{staticClass:"tag",attrs:{"to":{name: 'JobsList', query: {q: tag}},"title":tag}},[_c('i',{staticClass:"dot is-primary"}),_c('span',[_vm._v(_vm._s(tag))])])],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-297ffcc6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/job-tags.vue
// module id = null
// module chunks = 